/**
 * ImageFormat represents the set of image formats that media
 * can be converted into using Dynamic Imaging.
 */
export var ImageFormat;
(function (ImageFormat) {
    /**
     * JPEG (jpg) image format.
     */
    ImageFormat["JPEG"] = "jpg";
    /**
     * Portable Network Graphics (png) image format.
     */
    ImageFormat["PNG"] = "png";
    /**
     * Graphics Interchange Format (gif) image format.
     */
    ImageFormat["GIF"] = "gif";
    /**
     * WebP (webp) image format.
     */
    ImageFormat["WEBP"] = "webp";
    /**
     * Bitmap (bmp) image format.
     */
    ImageFormat["BITMAP"] = "bmp";
})(ImageFormat || (ImageFormat = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW1hZ2VGb3JtYXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL21lZGlhL21vZGVsL0ltYWdlRm9ybWF0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7R0FHRztBQUNILE1BQU0sQ0FBTixJQUFZLFdBeUJYO0FBekJELFdBQVksV0FBVztJQUNyQjs7T0FFRztJQUNILDJCQUFZLENBQUE7SUFFWjs7T0FFRztJQUNILDBCQUFXLENBQUE7SUFFWDs7T0FFRztJQUNILDBCQUFXLENBQUE7SUFFWDs7T0FFRztJQUNILDRCQUFhLENBQUE7SUFFYjs7T0FFRztJQUNILDZCQUFjLENBQUE7QUFDaEIsQ0FBQyxFQXpCVyxXQUFXLEtBQVgsV0FBVyxRQXlCdEIifQ==